var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16a1 1 0 0 1 1 1v4a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 2 0v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a1 1 0 0 1 1 1l-.007 15.427L15.92 13.5a1 1 0 0 1 1.379.032 1 1 0 0 1 .035 1.38l-3.21 3.21a3 3 0 0 1-4.245 0l-3.211-3.207A1 1 0 0 1 8.081 13.5l2.91 2.908L11 1a1 1 0 0 1 1-1"
  })));
};
export default SvgDownload;